import { Maybe } from './types';

/**
 * Gets the error message from an unknown error. If `error` is an `Error`, it
 * will return the `message` property. Otherwise, it will return the string
 * representation of `error`.
 *
 * @param error Possibly an `Error`
 * @returns String representation of `error`
 */
export function getErrorMessage(error: unknown): string {
  return (error as Maybe<Error>)?.message ?? String(error);
}
